module.exports = __webpack_public_path__ + "img/caselist24.8148d029.jpg";